import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = { class: "row" };
var _hoisted_2 = { class: "col-12 col-md-6 col-lg-3" };
var _hoisted_3 = {
    key: 0,
    class: "card"
};
var _hoisted_4 = { class: "card-body" };
var _hoisted_5 = { class: "subs disabled" };
var _hoisted_6 = { class: "text-center" };
var _hoisted_7 = { class: "text-center" };
var _hoisted_8 = { class: "row pt-4" };
var _hoisted_9 = { class: "col-12 col-sm-4" };
var _hoisted_10 = { class: "col-12 col-sm-8" };
var _hoisted_11 = { class: "text-end" };
var _hoisted_12 = { class: "col-12" };
var _hoisted_13 = { class: "row" };
var _hoisted_14 = ["onClick"];
var _hoisted_15 = { key: 1 };
var _hoisted_16 = { class: "col-12" };
var _hoisted_17 = { class: "d-flex justify-content-center" };
var _hoisted_18 = ["onClick"];
var _hoisted_19 = { class: "col-12 col-md-6 col-lg-4" };
var _hoisted_20 = {
    key: 0,
    class: "card"
};
var _hoisted_21 = { class: "card-body" };
var _hoisted_22 = { class: "subs enabled" };
var _hoisted_23 = { class: "text-center" };
var _hoisted_24 = { class: "text-center" };
var _hoisted_25 = { class: "row pt-4" };
var _hoisted_26 = { class: "col-12 col-sm-8 col-md-9" };
var _hoisted_27 = { class: "col-12 col-sm-4 col-md-3" };
var _hoisted_28 = { class: "col-12 col-sm-8 col-md-9" };
var _hoisted_29 = { class: "col-12 col-sm-4 col-md-3" };
var _hoisted_30 = {
    class: "modal fade",
    id: "document-viewer",
    tabindex: "-1",
    "aria-hidden": "true"
};
var _hoisted_31 = { class: "modal-dialog" };
var _hoisted_32 = { class: "modal-content" };
var _hoisted_33 = {
    key: 0,
    class: "modal-body"
};
var _hoisted_34 = ["src"];
import { onMounted, ref } from 'vue';
import { Modal } from 'bootstrap';
import { notify } from '@/utils/toast';
import { toast } from 'vue3-toastify';
import { dateFormat } from '@/utils/dateformat';
import { useAuthStore } from '@/stores/authStore';
import { subsPending, approveSub } from '@/api/admin/clients';
import { getGroups } from '@/api/admin/platforms';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DashboardAdmin',
    setup: function (__props) {
        var _this = this;
        var _a;
        var auth = useAuthStore();
        var role = ref((_a = auth.user) === null || _a === void 0 ? void 0 : _a.role);
        var paymentSel = ref(null);
        var subsDis = ref([]);
        var groups = ref([]);
        var API = process.env.VUE_APP_BACKEND_URL !== undefined ? process.env.VUE_APP_BACKEND_URL : 'http://localhost:3000';
        onMounted(function () {
            onSubsPending();
            onActiveGroups();
        });
        var onSubsPending = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        subsDis.value = [];
                        return [4 /*yield*/, subsPending()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            subsDis.value = response.data.subsToConfirm;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var onActiveGroups = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        groups.value = [];
                        return [4 /*yield*/, getGroups({ status: 'activo' })];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            groups.value = response.data.data.rows;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var approve = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var response, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, approveSub(id)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            onSubsPending();
                            onActiveGroups();
                            notify('Suscripción aprobada', 'success', toast.POSITION.BOTTOM_CENTER);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        function openModal(pay) {
            paymentSel.value = pay;
            var modalElement = document.getElementById('document-viewer');
            var modalInstance = new Modal(modalElement);
            modalInstance.show();
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (subsDis.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "text-center" }, "Suscripciones pendientes", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subsDis.value, function (sub) {
                                    var _a, _b, _c;
                                    return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createElementVNode("h5", _hoisted_6, [
                                            _createElementVNode("strong", null, _toDisplayString((_b = (_a = sub.group) === null || _a === void 0 ? void 0 : _a.platform) === null || _b === void 0 ? void 0 : _b.name), 1)
                                        ]),
                                        _createElementVNode("h6", _hoisted_7, _toDisplayString((_c = sub.group) === null || _c === void 0 ? void 0 : _c.groupName), 1),
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _createElementVNode("dl", null, [
                                                    _cache[0] || (_cache[0] = _createElementVNode("dt", null, "Precio", -1)),
                                                    _createTextVNode("$us " + _toDisplayString(sub.cost), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_10, [
                                                _createElementVNode("dl", _hoisted_11, [
                                                    _cache[1] || (_cache[1] = _createElementVNode("dt", null, "Fecha de solicitud", -1)),
                                                    _createTextVNode(_toDisplayString(_unref(dateFormat)(sub.createdAt, 'DD MMMM - hh:mm')), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_12, [
                                                _cache[3] || (_cache[3] = _createElementVNode("h5", null, "Comprobantes", -1)),
                                                _createElementVNode("div", _hoisted_13, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sub.vouchers, function (vouc) {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            class: _normalizeClass({ 'col-4': vouc.method === 'meru', 'col-12': vouc.method !== 'meru' })
                                                        }, [
                                                            (vouc.method === 'meru')
                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                    key: 0,
                                                                    class: "w-100",
                                                                    onClick: function ($event) { return (openModal(vouc)); }
                                                                }, [
                                                                    _cache[2] || (_cache[2] = _createElementVNode("img", {
                                                                        class: "img-fluid",
                                                                        src: "/imagenes/subscription_cover.png"
                                                                    }, null, -1)),
                                                                    _createElementVNode("span", null, _toDisplayString(vouc.transactionId), 1)
                                                                ], 8, _hoisted_14))
                                                                : (_openBlock(), _createElementBlock("p", _hoisted_15, "Paypal ID: " + _toDisplayString(vouc.transactionId), 1))
                                                        ], 2));
                                                    }), 256))
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("button", {
                                                        class: "btn btn-warning text-dark",
                                                        onClick: function ($event) { return (approve(sub.id)); }
                                                    }, _cache[4] || (_cache[4] = [
                                                        _createElementVNode("strong", null, "Aprobar", -1)
                                                    ]), 8, _hoisted_18)
                                                ])
                                            ])
                                        ]),
                                        _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1))
                                    ]));
                                }), 256))
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_19, [
                    (groups.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "text-center" }, "Cuentas activas", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, function (gr) {
                                    var _a;
                                    return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        _createElementVNode("h4", _hoisted_23, _toDisplayString(gr.groupName), 1),
                                        _createElementVNode("h5", _hoisted_24, _toDisplayString((_a = gr.platform) === null || _a === void 0 ? void 0 : _a.name), 1),
                                        _createElementVNode("div", _hoisted_25, [
                                            _createElementVNode("div", _hoisted_26, [
                                                _createElementVNode("dl", null, [
                                                    _cache[7] || (_cache[7] = _createElementVNode("dt", null, "Cuenta", -1)),
                                                    _createTextVNode(_toDisplayString(gr.accountEmail), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_27, [
                                                _createElementVNode("dl", null, [
                                                    _cache[8] || (_cache[8] = _createElementVNode("dt", null, "Costo", -1)),
                                                    _createTextVNode("$us " + _toDisplayString(gr.currentCost), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_28, [
                                                _createElementVNode("dl", null, [
                                                    _cache[9] || (_cache[9] = _createElementVNode("dt", null, "Perfiles", -1)),
                                                    _createTextVNode(_toDisplayString(gr.subscriptions.length) + " de " + _toDisplayString(gr.availableProfiles), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_29, [
                                                _createElementVNode("dl", null, [
                                                    _cache[10] || (_cache[10] = _createElementVNode("dt", null, "Expira", -1)),
                                                    _createTextVNode(_toDisplayString(_unref(dateFormat)(gr.expiredAt, 'DD MMM')), 1)
                                                ])
                                            ]),
                                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-12 col-sm-12 col-md-4" }, null, -1))
                                        ]),
                                        _cache[12] || (_cache[12] = _createElementVNode("hr", null, null, -1))
                                    ]));
                                }), 256)),
                                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "row justify-content-center" }, [
                                    _createElementVNode("div", { class: "col-12 col-sm-9 col-md-7" }, [
                                        _createElementVNode("a", {
                                            class: "btn btn-outline-info w-100",
                                            href: "/admin/groups"
                                        }, "Ver todas las cuentas")
                                    ])
                                ], -1))
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "d-none d-md-block col-md-6 col-lg-5" }, " Chat ", -1)),
                _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                            (paymentSel.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("img", {
                                        class: "img-fluid",
                                        src: _unref(API) + '/payments/documents/' + paymentSel.value.id
                                    }, null, 8, _hoisted_34)
                                ]))
                                : _createCommentVNode("", true),
                            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "modal-footer" }, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    "data-bs-dismiss": "modal"
                                }, "Cerrar")
                            ], -1))
                        ])
                    ])
                ])
            ]));
        };
    }
});
